import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { firebaseApp, isFirebaseConfigured } from '../firebase/config';

const FirebaseAuthContext = createContext({
  user: null,
  loading: false,
});

export function FirebaseAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(() => isFirebaseConfigured());

  useEffect(() => {
    if (!isFirebaseConfigured() || !firebaseApp) {
      setLoading(false);
      return undefined;
    }

    const auth = getAuth(firebaseApp);
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        try {
          const token = await u.getIdToken();
          localStorage.setItem('token', token);
          localStorage.setItem('auth_provider', 'firebase');
          localStorage.setItem(
            'user_data',
            JSON.stringify({
              email: u.email,
              uid: u.uid,
              displayName: u.displayName || '',
            })
          );
        } catch (e) {
          console.error('Firebase ID token error:', e);
        }
      } else if (localStorage.getItem('auth_provider') !== 'demo') {
        localStorage.removeItem('token');
        localStorage.removeItem('user_data');
        localStorage.removeItem('auth_provider');
      }
      setLoading(false);
    });

    return unsub;
  }, []);

  return (
    <FirebaseAuthContext.Provider value={{ user, loading }}>
      {children}
    </FirebaseAuthContext.Provider>
  );
}

export function useFirebaseAuth() {
  return useContext(FirebaseAuthContext);
}
